/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
import { ScreenshotFromJSON, ScreenshotFromJSONTyped, ScreenshotToJSON, ScreenshotToJSONTyped, } from './Screenshot';
/**
 * Check if a given object implements the Game interface.
 */
export function instanceOfGame(value) {
    return true;
}
export function GameFromJSON(json) {
    return GameFromJSONTyped(json, false);
}
export function GameFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['Id'] == null ? undefined : json['Id'],
        'name': json['Name'] == null ? undefined : json['Name'],
        'developerId': json['DeveloperId'] == null ? undefined : json['DeveloperId'],
        'publisherId': json['PublisherId'] == null ? undefined : json['PublisherId'],
        'setting': json['Setting'] == null ? undefined : json['Setting'],
        'style': json['Style'] == null ? undefined : json['Style'],
        'genre': json['Genre'] == null ? undefined : json['Genre'],
        'perspective': json['Perspective'] == null ? undefined : json['Perspective'],
        'screenshots': json['Screenshots'] == null ? undefined : (json['Screenshots'].map(ScreenshotFromJSON)),
    };
}
export function GameToJSON(json) {
    return GameToJSONTyped(json, false);
}
export function GameToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Id': value['id'],
        'Name': value['name'],
        'DeveloperId': value['developerId'],
        'PublisherId': value['publisherId'],
        'Setting': value['setting'],
        'Style': value['style'],
        'Genre': value['genre'],
        'Perspective': value['perspective'],
        'Screenshots': value['screenshots'] == null ? undefined : (value['screenshots'].map(ScreenshotToJSON)),
    };
}
